import { render } from "./MainExternalShopping.vue?vue&type=template&id=1401d0d0&scoped=true"
import script from "./MainExternalShopping.vue?vue&type=script&lang=js"
export * from "./MainExternalShopping.vue?vue&type=script&lang=js"

import "./MainExternalShopping.vue?vue&type=style&index=0&id=1401d0d0&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1401d0d0"]])

export default __exports__